<template>
  <el-form
    ref="form"
    :model="form"
    label-width="80px"
    class="group-form"
  >
    <el-form-item
      label="群发标题"
      required
    >
      <el-input
        v-model="form.title"
        placeholder="请输入群发标题"
        maxlength="20"
        show-word-limit
        class="input-title"
        :disabled="!form.is_delete"
      />
    </el-form-item>
    <el-form-item label="发送范围">
      <el-radio-group
        v-model="form.chat_range"
        :disabled="!form.is_delete"
      >
        <el-radio :label="1">
          全部客户
        </el-radio>
        <el-radio :label="2">
          按条件筛选客户
        </el-radio>
      </el-radio-group>
    </el-form-item>

    <template v-if="form.chat_range === 2">
      <el-form-item label="添加人">
        <template v-if="showList.length <= 0">
          <el-button
            :disabled="!form.is_delete"
            icon="el-icon-plus"
            type="primary"
            @click="showBox = true"
          >
            添加人员
          </el-button>
        </template>

        <template v-else>
          <div
            class="el-button"
            @click="showBox = true"
          >
            <div class="guide-box">
              <template v-for="(item, index) in showList">
                <div
                  v-if="item.salesperson_id"
                  :key="index"
                  class="guide-number"
                >
                  <img
                    v-if="item.salesperson_avatar"
                    :src="item.salesperson_avatar"
                    alt=""
                    class="pic"
                  >
                  {{ item.salesperson_name }}
                </div>
              </template>
            </div>
          </div>
        </template>
        <SpGuideBox
          v-model="showBox"
          :call-data="callData"
          :disabled-node="true"
          @getUserList="getUserList"
        />
      </el-form-item>

      <el-form-item label="添加时间">
        <el-date-picker
          v-model="form.add_time"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          :disabled="!form.is_delete"
          @change="addtimeChange"
        />
      </el-form-item>

      <el-form-item label="客户标签">
        <div>
          <span>筛选【满足以下任意标签】的客户</span>
          <el-button
            :disabled="!form.is_delete"
            class="add-label-btn"
            type="text"
            @click="showBatchTagging = true"
          >
            修改
          </el-button>
        </div>
        <div class="babel-list-box">
          <el-tag
            v-for="item in form.tag"
            :key="item.id"
            :closable="form.is_delete"
            type="info"
            :disable-transitions="false"
            @close="handleClose(item)"
          >
            {{ item.title }}
          </el-tag>
        </div>

        <SpBatchLabel
          v-model="showBatchTagging"
          :tags-list="form.tag"
          :selection-babel="true"
          :show-selected-tags="true"
          @selectBabelList="batchTagging"
        />
      </el-form-item>
      <el-form-item label="客户身份">
        <el-radio-group
          v-model="form.member_status"
          @change="getSendCount"
        >
          <el-radio :label="0">
            不限
          </el-radio>
          <el-radio :label="1">
            会员
          </el-radio>
          <el-radio :label="2">
            非会员
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- <el-form-item label="剔除标签">
        <div class="babel-list-box">
          <el-tag
            v-for="item in form.tag_exclude"
            :key="item.id"
            :closable="form.is_delete"
            type="info"
            :disable-transitions="false"
            @close="handleExcludeClose(item)"
          >
            {{ item.title }}
          </el-tag>
          <el-button
            :disabled="!form.is_delete"
            class="remove-label-btn"
            type="text"
            @click="showExcludeBatchTagging = true"
          >
            选择标签
          </el-button>
        </div>

        <SpBatchLabel
          v-model="showExcludeBatchTagging"
          :tags-list="form.tag_exclude"
          :selection-babel="true"
          :show-selected-tags="true"
          @selectBabelList="batchExcludeTagging"
        />
      </el-form-item> -->
    </template>

    <el-form-item label="">
      <span class="tips">消息预计送达人数 {{ count }}</span>
    </el-form-item>

    <el-form-item label="发送时间">
      <el-date-picker
        v-model="form.sent_at"
        class="m-r-6"
        type="datetime"
        placeholder="选择日期时间"
        value-format="yyyy-MM-dd HH:mm:ss"
        :disabled="!form.is_delete"
      />
      <span class="tips">设置时间定时发送，不设置立即发送</span>
    </el-form-item>

    <el-form-item
      label="发送内容"
      required
    >
      <el-input
        v-model="form.text"
        class="text-area"
        type="textarea"
        placeholder="请输入内容"
        :disabled="!form.is_delete"
      />
    </el-form-item>

    <el-form-item label="">
      <template>
        <div
          v-for="(item, index) in form.attachments"
          :key="index"
        >
          {{ msgType[item.msgtype] }}：{{
            item[item.msgtype].title || msgType[item.msgtype] + (index + 1)
          }}
          <i
            v-if="form.is_delete"
            class="el-icon-close close-btn"
            @click="deleteAttachments(index)"
          />
        </div>
      </template>
    </el-form-item>

    <el-form-item
      v-if="form.is_delete"
      label=""
    >
      <el-button
        type="primary"
        plain
        size="small"
        @click="newAddAttachment"
      >
        + 添加附件
      </el-button>

      <SpAttachment
        v-model="addAttachment"
        @addAttachmentData="addAttachmentData"
      />
    </el-form-item>

    <el-form-item
      v-if="form.is_delete"
      label=""
    >
      <el-button
        type="primary"
        @click="submitGroupDetail"
      >
        通知成员发送
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  data () {
    return {
      msgType: {
        'image': '图片',
        'video': '视频',
        'item': '商品',
        'coupon': '优惠券',
        'miniprogram': '页面'
      },
      form: {
        chat_range: 1,
        chat_type: 1,
        salesperson_ids: [],
        attachments: [],
        tag: [],
        tag_exclude: [],
        is_delete: true,
        sent_at: '',
        add_time: ['', ''],
        member_status: 0
      },
      showBox: false,
      showList: [],
      callData: {},
      addAttachment: false,
      showBatchTagging: false,
      showExcludeBatchTagging: false,
      count: 0
    }
  },
  mounted () {
    let params = this.$route.params
    if (+params.id) {
      this.init(params.id)
    } else {
      this.$emit('getAttachment', [])
      this.getSendCount()
    }
  },
  methods: {
    async getSendCount () {
      let params = {
        salesperson_ids: this.form.salesperson_ids,
        tag_ids: this.form.tag.map((v) => v.id),
        tag_exclude_ids: this.form.tag_exclude.map((v) => v.id),
        add_start_time: (this.form.add_time && this.form.add_time[0]) || '',
        add_end_time: (this.form.add_time && this.form.add_time[1]) || '',
        member_status: this.form.member_status
      }
      const data = await this.$api.membership.sendCount(params)
      if (data) {
        this.count = data.count
      }
    },
    async init (id) {
      const data = await this.$api.membership.getGroupmsgInfo(id)
      if (data) {
        data.sent_at = data.sent_at_str
        data.add_time = [data.add_start_time_str || '', data.add_end_time_str || '']
        this.form = data
        this.$emit('getAttachment', data.attachments)
        // 处理导购数据
        this.guideData(data)
      }
    },
    getUserList (e) {
      if (e.userList.length > 100) {
        return this.$message.error('导购选择不能超过100条')
      }

      if (e.userList.length > 0) {
        e.userList.map((v) => {
          v.salesperson_name = v.name
        })
      }
      this.showBox = false
      this.callData = e
      this.showList = [].concat(e.userList).slice(0, 2)
      this.getIds(e)
    },
    // 处理导购数据
    guideData (data) {
      if (data.salesperson.length > 0) {
        data.salesperson.map((v) => {
          v.name = v.salesperson_name
          v.userid = v.salesperson_id
        })
      }
      this.callData = {
        userList: data.salesperson
      }
      this.showList = [].concat(data.salesperson).slice(0, 2)
      this.getIds(this.callData)
    },
    getIds (data) {
      let userListId = []
      data.userList.forEach((v) => {
        userListId.push(v.salesperson_id)
      })
      this.form.salesperson_ids = userListId
      this.getSendCount()
    },

    newAddAttachment () {
      if (this.form.attachments.length < 9) {
        this.addAttachment = true
      } else {
        this.$message.error('最多添加9个附件！')
      }
    },

    addAttachmentData (data) {
      this.form.attachments.push(data)
      this.addAttachment = false
      this.$emit('getAttachment', this.form.attachments)
    },

    async submitGroupDetail () {
      if (!this.form.title) {
        return this.$message.error('请填写群发标题！')
      } else if (!this.form.text) {
        return this.$message.error('请填写发送内容！')
      }

      if (this.form.tag.length > 0 || this.form.tag_exclude.length > 0) {
        for (let i = 0; i < this.form.tag_exclude.length; i++) {
          if (this.form.tag.findIndex((item) => item.id === this.form.tag_exclude[i].id) !== -1) {
            return this.$message.error('剔除标签不可与客户标签重复！')
          }
        }
      }

      let id = this.$route.params.id
      let params = Object.assign({}, this.form, {
        tag_ids: this.form.tag.map((v) => v.id),
        tag_exclude_ids: this.form.tag_exclude.map((v) => v.id),
        add_start_time: (this.form.add_time && this.form.add_time[0]) || '',
        add_end_time: (this.form.add_time && this.form.add_time[1]) || ''
      })
      if (+id) {
        const data = await this.$api.membership.updateGroupMsg(id, params)
        if (data) {
          this.$message.success('更新成功！')
          this.$router.push({
            path: '/membership/customerGroup'
          })
        }
      } else {
        const data = await this.$api.membership.createGroupMsg(params)
        if (data) {
          this.$message.success('创建成功！')
          this.$router.push({
            path: '/membership/customerGroup'
          })
        }
      }
    },

    deleteAttachments (index) {
      this.form.attachments.splice(index, 1)
    },

    handleClose (item) {
      let index = this.form.tag.findIndex((v) => v.id === item.id)
      this.form.tag.splice(index, 1)
      this.getSendCount()
    },
    batchTagging (list) {
      if (list.length <= 7) {
        this.form.tag = list
        this.showBatchTagging = false
        this.getSendCount()
      } else {
        this.$message.error('最多添加7个标签！')
      }
    },

    // 剔除标签
    handleExcludeClose (item) {
      let index = this.form.tag_exclude.findIndex((v) => v.id === item.id)
      this.form.tag_exclude.splice(index, 1)
      this.getSendCount()
    },
    batchExcludeTagging (list) {
      if (list.length <= 7) {
        this.form.tag_exclude = list
        this.showExcludeBatchTagging = false
        this.getSendCount()
      } else {
        this.$message.error('最多添加7个标签！')
      }
    },

    addtimeChange (val) {
      if (val == null) {
        val = ['', '']
      }
      this.form.add_time = val
      this.getSendCount()
    }
  }
}
</script>

<style lang="scss" scoped>
.tips {
  color: #9a9097;
  font-size: 12px;
}
.text-area {
  width: 400px;
}
.guide-box {
  display: flex;
  align-items: center;
  width: auto;
  .guide-number {
    display: flex;
    align-items: center;
    .pic {
      display: inline-block;
      width: 18px;
      height: 18px;
      margin-right: 4px;
      border-radius: 50%;
    }
    margin-right: 10px;
  }
  .guide-deparment {
    display: flex;
    align-items: center;
    .pic-folder {
      display: inline-block;
      width: 18px;
      height: 18px;
      background: url('../../../../assets/img/folder.png') no-repeat;
      background-size: contain;
      margin-right: 4px;
    }
  }
}
.close-btn {
  cursor: pointer;
  margin-left: 10px;
}
.group-form {
  width: 800px;
}
.babel-list-box {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .el-tag {
    margin-right: 10px;
    margin-bottom: 10px;
  }
}
.add-label-btn {
  margin-left: 10px;
}
.remove-label-btn {
  padding: 0 6px;
  height: 40px;
  // font-size: 12px;
  // margin-bottom: 10px;
}
.input-title {
  width: 400px;
}
</style>
